import { ICON__scaling } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__dropdown_menu } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu';
import { UI_PRIMITIVE__dropdown_menu_content } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_content';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { UI_PRIMITIVE__dropdown_menu_trigger } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_trigger';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_8_5 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_8_5';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { cn } from '@/utils/utils_client';
import { assert_array_includes } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { ENUM__image_transform } from '@shared/dto/generation/graph_invoke/_fields/image/_enums/ENUM__image_transform';

interface PROPS {
  field: FIELD__list_image_asset;
}

export function G_DROPDOWN__field_image_asset_list__transform({ field }: PROPS) {
  /*
   * STORE
   */

  const { generation_current } = use_slice_generation(['generation_current']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  const preprocessing_transform__current: ENUM__image_transform = field.item_options.get_or_assert('preprocessing_transform__current');
  const preprocessing_transform__allowed: ENUM__image_transform[] = field.item_options.get_or_assert('preprocessing_transform__allowed');

  /*
   * STATE
   */

  /*
   * EVENTS
   */
  async function on_item_selected(value: ENUM__image_transform) {
    if (value == preprocessing_transform__current) return;

    assert_array_includes(preprocessing_transform__allowed, value);

    let field_new = field.clone();
    field_new.item_options.set('preprocessing_transform__current', value);

    for (let item of field_new.items) item.preprocessing_transform__current = value;

    let graph_new = generation_current.tool.graph.clone();

    graph_new.field__replace(field_new);

    await UTILS__graph_data.update(graph_new);
  }

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   *
   */

  function render_item(value: ENUM__image_transform) {
    return (
      <UI_PRIMITIVE__dropdown_menu_item
        key={`field_store_interaction_${value}`}
        values_selected={[preprocessing_transform__current]}
        class_name_hovered_selected="bg-component-item-selected"
        className={cn('px-2 py-0.5 cursor-pointer text-xs bg-component text-component-item-foreground')}
        value={value}
        on_item_selected={() => void on_item_selected(value)}
      >
        {value}
      </UI_PRIMITIVE__dropdown_menu_item>
    );
  }

  function render_view() {
    return (
      <>
        <UI_PRIMITIVE__dropdown_menu modal={false}>
          <UI_PRIMITIVE__dropdown_menu_trigger asChild>
            <UI_PRIMITIVE__button
              title={'Store between tools'}
              variant={'no-border-on-bar'}
              disabled={is_disabled()}
              onClick={() => {}}
              className={`w-8 h-5  flex-center ${preprocessing_transform__current == ENUM__image_transform.NONE ? 'opacity-50' : ''}`}
            >
              <ICON__scaling className="size-3 flex-shrink-0 text-gray-400" />
            </UI_PRIMITIVE__button>
          </UI_PRIMITIVE__dropdown_menu_trigger>

          <UI_PRIMITIVE__dropdown_menu_content
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg dark:bg-component dark:border-component-border p-0"
            align="start"
            side="bottom"
            sideOffset={4}
          >
            {Object.values(preprocessing_transform__allowed).map(render_item)}
          </UI_PRIMITIVE__dropdown_menu_content>
        </UI_PRIMITIVE__dropdown_menu>
      </>
    );
  }

  /*
   * HTML
   */
  if (field.items.is_empty()) return <PLACEHOLDER_BUTTON__bar_8_5 />;
  if (preprocessing_transform__allowed.length <= 1) return <PLACEHOLDER_BUTTON__bar_8_5 />;
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)) return <PLACEHOLDER_BUTTON__bar_8_5 />;

  return render_view();
}
